import React from 'react';
import { NavLink } from 'react-router-dom';
//import { useHistory } from 'react-router-dom';
//import { browserHistory } from 'react-router'
//import './styles/css2.css';
import './styles/css1.css';
import { withRouter } from 'react-router'
import Chart from "react-apexcharts"
import ApexCharts from 'apexcharts'
import ReactDOM from 'react-dom'
import { CSVReader } from 'react-papaparse'
//import { template } from '../public/pos_template.csv'
import ReactTable from 'react-table-6'
import 'react-table-6/react-table.css'

var data_query = []
var devices = ''
var device = ''
var age_groups = []
var date_string = ''
var hours = []
var hour_count = 23
var hour_string = '11:00 pm'
var hourly_counts = []
var date_string_on_load = ''//used to get song list
var time_selected = 'daily'

export default class ReportingDashboard extends React.Component {

  constructor(props) {

    super(props);
          this.state = {
          song_data: [],
          series: [{
                name: "Customers",
                //data: [1,2,3]
                //data: []
            }],
            options: {
              chart: {
                  events: {
                      dataPointSelection: function(e, chart, opt){
                       console.log(opt);
                       console.log(e);
                       console.log(data_query.length)
                       console.log(data_query)
                       console.log('yesterday: ' + data_query[data_query.length-2].toString())
                       console.log('clicked: ' + data_query[opt.dataPointIndex].toString())
                       console.log('devices: ' + devices)
                       console.log('device: ' + device)
                       console.log('time_selected: ' + time_selected)
                       if(time_selected=='daily'){

                        //get age demographics
                        var xhr3 = new XMLHttpRequest()
                        xhr3.addEventListener('load', () => {
                        var data = JSON.parse(xhr3.responseText);//parse response text into data object
                        console.log(data)
                        age_groups = data
                        date_string = data_query[opt.dataPointIndex].toString().replace("'","")
                        date_string = date_string.replace("'","")
                           ApexCharts.exec('chart2', 'updateOptions', {
                                 series: [parseInt(data.age18_24), parseInt(data.age25_34), parseInt(data.age35_44), parseInt(data.age45_54),
                                  parseInt(data.age55_64), parseInt(data.age65)],
                                   title: {text: 'Customers by Age Group - ' + date_string}
                                 //series: [0,226,126,86,5,1]
                            })

                        //get gender demographics
                        var xhr4 = new XMLHttpRequest()
                        xhr4.addEventListener('load', () => {
                        var data = JSON.parse(xhr4.responseText);//parse response text into data object
                        console.log(data.male_count)
                        //update state of chart 3 here
                            ApexCharts.exec('chart3', 'updateOptions', {
                                 series: [parseInt(data.male_count), parseInt(data.female_count)],
                                 title: {text: 'Customers by Gender - ' + date_string}
                                 //series: [100,200]
                            })

                        //get hourly data
                        var xhr5 = new XMLHttpRequest()
                        xhr5.addEventListener('load', () => {
                        var data = JSON.parse(xhr5.responseText);//parse response text into data object
                        console.log(data.hours)
                        console.log(data.counts)
                        //update state of chart 4 here
                            ApexCharts.exec('chart4', 'updateOptions', {
                                series: [{name: "Customers Per Hour", data: data.counts}],
                                title: {text: 'Customers Per Hour - ' + date_string},
                                xaxis: {type: "datetime",
                                    categories: data.hours,
                //                    labels: {format: 'HH/TT' }
                                    },

                            })

                             hours = data.hours
                    console.log(data.hours)
                    console.log(data.counts)
                    hourly_counts = data.counts
                        console.log('hourly_counts: ' + hourly_counts)
                                    //get last hour with value grater than 0
                        var i = hourly_counts.length
                        for (i -1; i >= 0; i--){
                            if(hourly_counts[i] > 0){
                            console.log('index: ' + i.toString() + ' count: ' + hourly_counts[i])
                            break
                            }
                        }
                         hour_string = hours[i]
                         hour_count = i
                         console.log('hour_string: ' + hour_string)
                         console.log('hour_count: ' + hour_count)
                                                //get hourly age demographics
                        var xhr3 = new XMLHttpRequest()
                        xhr3.addEventListener('load', () => {
                        var data = JSON.parse(xhr3.responseText);//parse response text into data object
                        console.log(data)
                        //age_groups = data
//                        date_string = data_query[opt.dataPointIndex].toString().replace("'","")
//                        date_string = date_string.replace("'","")
                           console.log('hour_string: ' + hour_string)
                           ApexCharts.exec('chart5', 'updateOptions', {
                                 series: [parseInt(data.age18_24), parseInt(data.age25_34), parseInt(data.age35_44), parseInt(data.age45_54),
                                  parseInt(data.age55_64), parseInt(data.age65)],
                                   title: {text: 'Customers by Age Group - ' + date_string + " - " + hour_string}
                                 //series: [0,226,126,86,5,1]
                            })

                                                    //get hourly gender demographics
                        var xhr6 = new XMLHttpRequest()
                        xhr6.addEventListener('load', () => {
                        var data = JSON.parse(xhr6.responseText);//parse response text into data object
                        console.log(data)
                            ApexCharts.exec('chart6', 'updateOptions', {
                                 series: [parseInt(data.males), parseInt(data.females)],
                                 title: {text: 'Customers by Gender - ' + date_string + " - " + hour_string}
                                 //series: [100,200]
                            })

                                                                                    var xhr7 = new XMLHttpRequest()
                        xhr7.addEventListener('load', () => {
                        var data = JSON.parse(xhr7.responseText);//parse response text into data object
                        console.log(data)
                        console.log(data.songs_played[0][2])
                        date_string_on_load = date_string
                        if(new String(data.result).valueOf() === 'OK'){
//                        var date_string = new Date(data.songs_played[0][2]).toLocaleString()
//                        console.log(date_string)
                            this.setState({song_data: [{artist: data.songs_played[0][0],
                            title: data.songs_played[0][1], date_time: data.songs_played[0][2]}]})
                        for (var x = 1; x < data.songs_played.length; x++) {
                        //var date_string = new Date(data.songs_played[x][2]).toLocaleString()
//                        var date_string = new Date(data.songs_played[x][2]).toString()
//                            this.setState({song_data: [...this.state.song_data, ...[{artist: data.songs_played[x][0],
//                            title: data.songs_played[x][1], date_time: date_string}]]})
                            this.setState({song_data: [...this.state.song_data, ...[{artist: data.songs_played[x][0],
                            title: data.songs_played[x][1], date_time: data.songs_played[x][2]}]]})

                        }
                        }
                        //get daily emotion data
                        var xhr8 = new XMLHttpRequest()
                        xhr8.addEventListener('load', () => {
                        var data = JSON.parse(xhr8.responseText);//parse response text into data object
                        console.log(data)
                        console.log(data.result)
                        if(new String(data.result).valueOf() === 'OK'){
							ApexCharts.exec('emotion1', 'updateOptions', {
								 series: [parseInt(data.happy_count), parseInt(data.surprise_count), parseInt(data.neutral_count),
								 parseInt(data.sad_count), parseInt(data.fear_count), parseInt(data.disgust_count), parseInt(data.anger_count)],
								 title: {text: 'Customers\' Emotions - ' + date_string},
								 //series: [1,2,3,4,5,6,7]
							})

                        }
                        })

                       console.log(date_string_on_load)
						xhr8.open('POST', 'http://3.21.222.196:3035/get_emotion_by_date');//87 is considered unsafe by Chrome
                        xhr8.send(JSON.stringify({'device': device, 'date': date_string_on_load}));

                       })
						xhr7.open('POST', 'http://3.21.222.196:3035/get_songs_played_daily');//87 is considered unsafe by Chrome
                        xhr7.send(JSON.stringify({'device': device, 'date': date_string}));

                        })
                        xhr6.open('POST', 'http://3.21.222.196:3035/get_hourly_gender_demographics');//87 is considered unsafe by Chrome
                        xhr6.send(JSON.stringify({'device': device, 'date': date_string, 'hour': hour_count}));

                               })
                        xhr3.open('POST', 'http://3.21.222.196:3035/get_hourly_age_demographics');//87 is considered unsafe by Chrome
                        xhr3.send(JSON.stringify({'device': device, 'date': date_string, 'hour': hour_count}));

                        })
                        console.log(date_string)
                        xhr5.open('POST', 'http://3.21.222.196:3035/get_hourly_data');//87 is considered unsafe by Chrome
                        //xhr5.send(JSON.stringify({'device': device, date: data_query[data_query.length-2].toString()}));
                        xhr5.send(JSON.stringify({'device': device, date: date_string}));
                        })
                        xhr4.open('POST', 'http://3.21.222.196:3035/get_gender_demographics');//87 is considered unsafe by Chrome
                        xhr4.send(JSON.stringify({'device': device, date: data_query[opt.dataPointIndex].toString()}));
                        })
                        xhr3.open('POST', 'http://3.21.222.196:3035/get_age_demographics');//87 is considered unsafe by Chrome
                        xhr3.send(JSON.stringify({'device': device, date: data_query[opt.dataPointIndex].toString()}));

//                       ApexCharts.exec('chart2', 'updateOptions', {
//                       series: [44, 55, 13, 23, 45, 130]
//                       })
//                       ApexCharts.exec('chart3', 'updateOptions', {
//                       series: [44, 25]
//                       })
                       }//if statement weekly
                       else{
                       if(time_selected=='weekly'){
                       alert(time_selected)
                       }
                       }
                       }.bind(this),//**************this must be binded for the setState of songs played*************
                       beforeResetZoom: function(e, opts){
                       console.log('beforeResetZoom')
                       return {
                       //seriesName: 'Customers'
                       yaxis: [{
                       //
                       }]};
                       }

                           },
              id: 'chart1',
              background: '#22385c',
              foreColor: '#dddddd',
              type: 'area',
//              width: 550,
//              height: 350,
              stacked: false,
              zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: true
              },
              toolbar: {
                autoSelected: 'zoom'
              }
            },
          dataLabels: {
          enabled: false
        },
          fill: {
          colors: ['#11AAFF'],
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.7,
            opacityTo: 0.1,
            stops: [0, 90, 100]
          },
        },
          stroke: {
            width: 2,
            curve: "smooth",
            colors: ["#00AAFF"]
          },
          title: {
          text: 'Customers Per Day',
          align: 'left'
          },
          xaxis: {
//            type: "datetime",
//            categories: ['1/11/2020', '2/1/2020', '3/1/2020']
            //categories: []
          },

          markers: {
            size: 2
          },
                tooltip: {
                intersect: true,
                  shared: false,
                  y: {
                    formatter: function (val) {
                      return (val / 1).toFixed(0)
                    }
                  }
                }
                    },
//          seriesChart2: [44, 55, 13, 23, 45, 13],
            seriesChart2: [],
          optionsChart2: {
          chart: {
             events: {
                      dataPointSelection: function(e, chart, opt){
                       console.log(opt);
                       console.log(e);
                       console.log(age_groups)
                       console.log(opt.dataPointIndex)
                       console.log(Object.keys(age_groups)[opt.dataPointIndex])
                       var age_group_clicked = Object.keys(age_groups)[opt.dataPointIndex]
                       console.log(age_groups[age_group_clicked])
                       console.log(date_string )
                       var age_string = ''
                       switch(age_group_clicked){
                           case 'age18_24':
                               age_string = 'age 18 to 24'
                               break
                           case 'age25_34':
                               age_string = 'age 25 to 34'
                               break
                           case 'age35_44':
                               age_string = 'age 35 to 44'
                               break
                           case 'age45_54':
                               age_string = 'age 45 to 54'
                               break
                           case 'age55_64':
                               age_string = 'age 55 to 64'
                               break
                           default:
                               age_string = '65+'
                       }
                        //get gender demographics
                        var xhr6 = new XMLHttpRequest()
                        xhr6.addEventListener('load', () => {
                        var data = JSON.parse(xhr6.responseText);//parse response text into data object
                        console.log(data)
                            ApexCharts.exec('chart3', 'updateOptions', {
                                 series: [parseInt(data.males), parseInt(data.females)],
                                 title: {text: 'Customers by Gender - ' + date_string + " - " + age_string}
                                 //series: [100,200]
                            })
                        })

                                                //get gender demographics
                        var xhr7 = new XMLHttpRequest()
                        xhr7.addEventListener('load', () => {
                        var data = JSON.parse(xhr7.responseText);//parse response text into data object
                        console.log(data)
							ApexCharts.exec('emotion1', 'updateOptions', {
								 series: [parseInt(data.happy_count), parseInt(data.surprise_count), parseInt(data.neutral_count),
								 parseInt(data.sad_count), parseInt(data.fear_count), parseInt(data.disgust_count), parseInt(data.anger_count)],
								 title: {text: 'Customers\' Emotions - ' + date_string+ " - " + age_string},
								 //series: [1,2,3,4,5,6,7]
							})
                        })


                        xhr7.open('POST', 'http://3.21.222.196:3035/get_emotions_by_age');//87 is considered unsafe by Chrome
                        xhr7.send(JSON.stringify({'device': device, date: date_string, 'age_group': age_group_clicked}));




                        xhr6.open('POST', 'http://3.21.222.196:3035/get_demographics_by_age');//87 is considered unsafe by Chrome
                        xhr6.send(JSON.stringify({'device': device, date: date_string, 'age_group': age_group_clicked}));
                       },
                       beforeResetZoom: function(e, opts){
                       console.log('beforeResetZoom')
                       return {
                       //seriesName: 'Customers'
                       yaxis: [{
                       //
                       }]};
                       }
                           },
              id: 'chart2',
              background: '#22385c',
              foreColor: '#dddddd',
          },
              labels: ['18 to 24', '25 to 34', '35 to 44', '45 to 54', '55 to 64', '65+'],
              title: {
                  text: 'Customers by Age Group',
                  align: 'left'
          },
//          theme: {
//                  palette: 'palette2'
//              },
          },
          seriesChart3: [],
          optionsChart3: {
              chart: {
                  id: 'chart3',
                  background: '#22385c',
                  foreColor: '#dddddd',
              },
              labels: ['Male', 'Female'],
              title: {
                  text: 'Customers by Gender',
                  align: 'left'
          },
          },
          seriesChart4: [],
          optionsChart4: {
              chart: {
              type: 'line',
              events: {
                      dataPointSelection: function(e, chart, opt){
//                       console.log(opt);
//                       console.log(e);
//                       console.log(data_query.length)
                       console.log(data_query)
                       console.log(date_string)
//                       console.log('yesterday: ' + data_query[data_query.length-2].toString())
                       //console.log(opt.dataPointIndex)
                       console.log('clicked: ' + opt.dataPointIndex)
                       console.log('clicked: ' + hours[opt.dataPointIndex].toString())
                       console.log('devices: ' + devices)
                       console.log('device: ' + device)
                       hour_count = opt.dataPointIndex
                       hour_string = hours[opt.dataPointIndex]
//
                        //get hourly age demographics
                        var xhr3 = new XMLHttpRequest()
                        xhr3.addEventListener('load', () => {
                        var data = JSON.parse(xhr3.responseText);//parse response text into data object
                        console.log(data)
                        //age_groups = data
//                        date_string = data_query[opt.dataPointIndex].toString().replace("'","")
//                        date_string = date_string.replace("'","")
                           ApexCharts.exec('chart5', 'updateOptions', {
                                 series: [parseInt(data.age18_24), parseInt(data.age25_34), parseInt(data.age35_44), parseInt(data.age45_54),
                                  parseInt(data.age55_64), parseInt(data.age65)],
                                   title: {text: 'Customers by Age Group - ' + date_string + " - " + hours[opt.dataPointIndex].toString()}
                                 //series: [0,226,126,86,5,1]
                            })

                                                    //get hourly gender demographics
                        var xhr6 = new XMLHttpRequest()
                        xhr6.addEventListener('load', () => {
                        var data = JSON.parse(xhr6.responseText);//parse response text into data object
                        console.log(data)
                            ApexCharts.exec('chart6', 'updateOptions', {
                                 series: [parseInt(data.males), parseInt(data.females)],
                                 title: {text: 'Customers by Gender - ' + date_string + " - " + hour_string}
                                 //series: [100,200]
                            })
                        })
                        xhr6.open('POST', 'http://3.21.222.196:3035/get_hourly_gender_demographics');//87 is considered unsafe by Chrome
                        xhr6.send(JSON.stringify({'device': device, 'date': date_string, 'hour': hour_count}));

                               })
                        xhr3.open('POST', 'http://3.21.222.196:3035/get_hourly_age_demographics');//87 is considered unsafe by Chrome
                        xhr3.send(JSON.stringify({'device': device, 'date': date_string, 'hour': opt.dataPointIndex}));
                                       },

                   beforeResetZoom: function(e, opts){
                       console.log('beforeResetZoom')
                       return {
                       //seriesName: 'Customers'
                       yaxis: [{
                       //
                       }]};
                       }
                        },
                  id: 'chart4',
                  background: '#22385c',
                  foreColor: '#dddddd',
                  stacked: false,
              zoom: {
                type: 'x',
                enabled: true,
                autoScaleYaxis: true
              },
              toolbar: {
                autoSelected: 'zoom'
              }
              },
               dataLabels: {
                  enabled: false
                },
                markers: {
                    size: 2
                 },
                tooltip: {
                intersect: true,
                  shared: false,
                  y: {
                    formatter: function (val) {
                      return (val / 1).toFixed(0)
                    }
                  }
                },
                          title: {
          text: 'Customers Per Hour',
          align: 'left'
          },
//                    xaxis: {
//            type: "datetime",
//            //categories: ["0","1"]
//            //xaxis: {type: "datetime", categories: data.hours},
//            //categories: []
//          },
          },

         seriesChart5: [],
          optionsChart5: {
              chart: {
              events: {
                      dataPointSelection: function(e, chart, opt){
                       console.log(opt);
                       console.log(e);
                       console.log(age_groups)
                       console.log(opt.dataPointIndex)
                       console.log(Object.keys(age_groups)[opt.dataPointIndex])
                       var age_group_clicked = Object.keys(age_groups)[opt.dataPointIndex]
                       console.log(age_groups[age_group_clicked])
                       console.log(date_string )
                       var age_string = ''
                       switch(age_group_clicked){
                           case 'age18_24':
                               age_string = 'age 18 to 24'
                               break
                           case 'age25_34':
                               age_string = 'age 25 to 34'
                               break
                           case 'age35_44':
                               age_string = 'age 35 to 44'
                               break
                           case 'age45_54':
                               age_string = 'age 45 to 54'
                               break
                           case 'age55_64':
                               age_string = 'age 55 to 64'
                               break
                           default:
                               age_string = '65+'
                       }
                        //get hourly gender demographics
                        var xhr6 = new XMLHttpRequest()
                        xhr6.addEventListener('load', () => {
                        var data = JSON.parse(xhr6.responseText);//parse response text into data object
                        console.log(data)
                            ApexCharts.exec('chart6', 'updateOptions', {
                                 series: [parseInt(data.males), parseInt(data.females)],
                                 title: {text: 'Customers by Gender - ' + date_string + " - " + hour_string + ' - ' + age_string}
                                 //series: [100,200]
                            })
                        })
                        xhr6.open('POST', 'http://3.21.222.196:3035/get_hourly_demographics_by_age');//87 is considered unsafe by Chrome
                        xhr6.send(JSON.stringify({'device': device, 'date': date_string, 'age_group': age_group_clicked, 'hour': hour_count}));
                       },
                       beforeResetZoom: function(e, opts){
                       console.log('beforeResetZoom')
                       return {
                       //seriesName: 'Customers'
                       yaxis: [{
                       //
                       }]};
                       }
                           },

                  id: 'chart5',
                  background: '#22385c',
                  foreColor: '#dddddd',
              },
              labels: ['18 to 24', '25 to 34', '35 to 44', '45 to 54', '55 to 64', '65+'],
//              labels: ['Male', 'Female'],
//              title: {
//                  text: 'Customers by Gender',
//                  align: 'left'
//          },
          },
          seriesChart6: [],
          optionsChart6: {
              chart: {
                  id: 'chart6',
                  background: '#22385c',
                  foreColor: '#dddddd',
              },
              labels: ['Male', 'Female'],
              title: {
                  text: 'Customers by Gender',
                  align: 'left'
          },
          },

          seriesEmotion1: [],
          optionsEmotion1: {
              chart: {
                  id: 'emotion1',
                  background: '#22385c',
                  foreColor: '#dddddd',
              },
              labels: ['Happy', 'Surprise', 'Neutral', 'Sad', 'Fear', 'Disgust', 'Anger'],
              title: {
                  text: 'Customer Emotions',
                  align: 'left'
          },
          }

          };
     this.viewReport1 = this.viewReport1.bind(this)
     this.display_test = this.display_test.bind(this)
  }


readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

//   getSelection(e) {
//        console.log(e.target.value)
//   }

  display_test = () =>  {
      console.log('clicked')
  }

  componentDidMount() {
		var today = new Date();
		var dd = String(today.getDate()).padStart(2, '0');
		var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
		var yyyy = today.getFullYear();
       date_string_on_load = mm + '/' + dd + '/' + yyyy;
       console.log('email_cookie: ', this.readCookie('email'))
       console.log('test_data_cookie: ', this.readCookie('test_data'))
       var select_item = document.getElementById("device")
       var select_item2 = document.getElementById("device2")
       var option = document.createElement("option")
       var option2 = document.createElement("option2")
       var xhr1 = new XMLHttpRequest()
       xhr1.addEventListener('load', () => {
       this.data = JSON.parse(xhr1.responseText);//parse response text into data object
       console.log("response from server: " + this.data.result);
       if (this.data.result === "no_email"){
          this.props.history.push({
          pathname: '/login'
          })
          //break
          //const history = useHistory()

          //browserHistory.push('/login')
       }
       if (this.data.result === "OK") {
          console.log(this.data.result)
          console.log(this.data.location_desc[1])
          console.log(this.data.sn)
          devices = this.data.sn
          device = devices[0]
          for(var i=0;i<this.data.sn.length;i++){
             option = document.createElement("option")
              option.text = this.data.location_desc[i]
              option.value = this.data.location_desc[i]
              select_item.add(option)
          }
        }else{
              option = document.createElement("option")
              option.text = "No Devices Available"
              select_item.add(option)
        }
        //var select_item_report = document.getElementById("report")
        var xhr2 = new XMLHttpRequest()
        xhr2.addEventListener('load', () => {
        var data = JSON.parse(xhr2.responseText);//parse response text into data object
        console.log(data)
        data_query = data.report_data_dates
        console.log(data_query)
        if(data.result == 'OK'){
            ApexCharts.exec('chart1', 'updateOptions', {
                series: [{name: "Customers", data: data.report_data_counts}],
                xaxis: {type: "datetime", categories: data.report_data_dates},
                title: {text: 'Customers Per Day - ' + select_item.value}
            })
        }else{
            alert("No data for " + select_item.options[select_item.selectedIndex].value)
            return false
        }

        console.log("counts: " + data.report_data_counts);
        console.log("dates: " + data.report_data_dates);

        //get age demographics
        var xhr3 = new XMLHttpRequest()
        xhr3.addEventListener('load', () => {
        var data = JSON.parse(xhr3.responseText);//parse response text into data object
        age_groups = data
        console.log(data)
        if(data_query.length < 2){
            date_string = data_query[data_query.length-1].toString().replace("'","")
        }else{
            date_string = data_query[data_query.length-1].toString().replace("'","")//change to -2 to default to yesterday
        }
        date_string = date_string.replace("'","")
           ApexCharts.exec('chart2', 'updateOptions', {
                 series: [parseInt(data.age18_24), parseInt(data.age25_34), parseInt(data.age35_44), parseInt(data.age45_54),
                  parseInt(data.age55_64), parseInt(data.age65)],
                   title: {text: 'Customers by Age Group - ' + date_string}
                 //series: [0,226,126,86,5,1]
            })
        //update state of chart 2 here

        //get gender demographics
        var xhr4 = new XMLHttpRequest()
        xhr4.addEventListener('load', () => {
        var data = JSON.parse(xhr4.responseText);//parse response text into data object
        console.log(data.male_count)
        //update state of chart 3 here
            ApexCharts.exec('chart3', 'updateOptions', {
                 series: [parseInt(data.male_count), parseInt(data.female_count)],
                 title: {text: 'Customers by Gender - ' + date_string}
                 //series: [100,200]
            })
         //get hourly data
        var xhr5 = new XMLHttpRequest()
        xhr5.addEventListener('load', () => {
        var data = JSON.parse(xhr5.responseText);//parse response text into data object
        hours = data.hours
        console.log(data.hours)
        console.log(data.counts)
        hourly_counts = data.counts
        //update state of chart 4 here
            ApexCharts.exec('chart4', 'updateOptions', {
                series: [{name: "Customers Per Hour", data: data.counts}],
                title: {text: 'Customers Per Hour - ' + date_string},
                xaxis: {type: "datetime",
                    categories: data.hours,
//                    labels: {format: 'HH/TT' }
                    },
                type: 'line'

            })

                        //get hourly age demographics
                        console.log('hourly_counts: ' + hourly_counts)
                        //get last hour with value grater than 0
                        var i = hourly_counts.length
                        for (i -1; i >= 0; i--){
                            if(hourly_counts[i] > 0){
                            console.log('index: ' + i.toString() + ' count: ' + hourly_counts[i])
                            break
                            }
                        }
                         hour_string = hours[i]
                         hour_count = i
                         console.log('hour_string: ' + hour_string)
                         console.log('hour_count: ' + hour_count)

                        var xhr3 = new XMLHttpRequest()
                        xhr3.addEventListener('load', () => {
                        var data = JSON.parse(xhr3.responseText);//parse response text into data object
                        console.log(data)
                        //age_groups = data
//                        date_string = data_query[opt.dataPointIndex].toString().replace("'","")
//                        date_string = date_string.replace("'","")

                           ApexCharts.exec('chart5', 'updateOptions', {
                                 series: [parseInt(data.age18_24), parseInt(data.age25_34), parseInt(data.age35_44), parseInt(data.age45_54),
                                  parseInt(data.age55_64), parseInt(data.age65)],
                                   title: {text: 'Customers by Age Group - ' + date_string + " - " + hour_string}
                                 //series: [0,226,126,86,5,1]
                            })

                        //get hourly gender demographics
                        var xhr6 = new XMLHttpRequest()
                        xhr6.addEventListener('load', () => {
                        var data = JSON.parse(xhr6.responseText);//parse response text into data object
                        console.log(data)
                            ApexCharts.exec('chart6', 'updateOptions', {
                                 series: [parseInt(data.males), parseInt(data.females)],
                                 title: {text: 'Customers by Gender - ' + date_string + " - " + hour_string}
                                 //series: [100,200]
                            })
                        //get songs played daily
                        var xhr7 = new XMLHttpRequest()
                        xhr7.addEventListener('load', () => {
                        var data = JSON.parse(xhr7.responseText);//parse response text into data object
                        console.log(data)
                        console.log(data.result)
                        if(new String(data.result).valueOf() === 'OK'){
                        //console.log(data.songs_played[0][2])
//                        var date_string = new Date(data.songs_played[0][2]).toLocaleString()
//                        console.log(date_string)
                        //if(data.length > 0) {
                        for (var x = 0; x < data.songs_played.length; x++) {
                        //var date_string = new Date(data.songs_played[x][2]).toLocaleString()
//                        var date_string = new Date(data.songs_played[x][2]).toString()
//                            this.setState({song_data: [...this.state.song_data, ...[{artist: data.songs_played[x][0],
//                            title: data.songs_played[x][1], date_time: date_string}]]})
                            this.setState({song_data: [...this.state.song_data, ...[{artist: data.songs_played[x][0],
                            title: data.songs_played[x][1], date_time: data.songs_played[x][2]}]]})
                        }
                        }
                       //get daily emotion data
                        var xhr8 = new XMLHttpRequest()
                        xhr8.addEventListener('load', () => {
                        var data = JSON.parse(xhr8.responseText);//parse response text into data object
                        console.log(data)
                        console.log(data.result)
                        if(new String(data.result).valueOf() === 'OK'){
							ApexCharts.exec('emotion1', 'updateOptions', {
								 series: [parseInt(data.happy_count), parseInt(data.surprise_count), parseInt(data.neutral_count),
								 parseInt(data.sad_count), parseInt(data.fear_count), parseInt(data.disgust_count), parseInt(data.anger_count)],
								 title: {text: 'Customers\' Emotions - ' + date_string},
								 //series: [1,2,3,4,5,6,7]
							})

                        }
                        })

                       console.log(date_string_on_load)
						xhr8.open('POST', 'http://3.21.222.196:3035/get_emotion_by_date');//87 is considered unsafe by Chrome
                        xhr8.send(JSON.stringify({'device': device, 'date': date_string_on_load}));


                       })
                       console.log(date_string_on_load)
						xhr7.open('POST', 'http://3.21.222.196:3035/get_songs_played_daily');//87 is considered unsafe by Chrome
                        xhr7.send(JSON.stringify({'device': device, 'date': date_string_on_load}));
                        })
                        xhr6.open('POST', 'http://3.21.222.196:3035/get_hourly_gender_demographics');//87 is considered unsafe by Chrome
                        xhr6.send(JSON.stringify({'device': device, 'date': date_string, 'hour': hour_count}));

                               })
                        xhr3.open('POST', 'http://3.21.222.196:3035/get_hourly_age_demographics');//87 is considered unsafe by Chrome
                        xhr3.send(JSON.stringify({'device': device, 'date': date_string, 'hour': hour_count}));

        })
        xhr5.open('POST', 'http://3.21.222.196:3035/get_hourly_data');//87 is considered unsafe by Chrome
        //xhr5.send(JSON.stringify({'device': device, date: data_query[data_query.length-2].toString()}));
        xhr5.send(JSON.stringify({'device': device, date: date_string}));



        })
        xhr4.open('POST', 'http://3.21.222.196:3035/get_gender_demographics');//87 is considered unsafe by Chrome
        if(data_query.length < 2){
            xhr4.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));
        }else{
            xhr4.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));//change to -2 to default to yesterday
        }

        })
        xhr3.open('POST', 'http://3.21.222.196:3035/get_age_demographics');//87 is considered unsafe by Chrome
        if(data_query.length < 2){
            xhr3.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));
        }else{
            xhr3.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));//change to -2 to default to yesterday
        }
        })
        xhr2.open('POST', 'http://3.21.222.196:3035/get_report');//87 is considered unsafe by Chrome
        xhr2.setRequestHeader("Content-Type", "application/json");
        //xhr2.send(JSON.stringify({'device': this.data.sn[select_item.selectedIndex], 'report': select_item_report.value}));
        if (this.data.result != "no_email"){
        xhr2.send(JSON.stringify({'device': this.data.sn[select_item.selectedIndex], 'report': 'total_customers_by_date'}));
        }

        })
        xhr1.open('POST', 'http://3.21.222.196:3035/get_devices');//87 is considered unsafe by Chrome
        xhr1.setRequestHeader("Content-Type", "application/json");
        xhr1.send(JSON.stringify({'email': this.readCookie('email')}));

}

  viewReport1 = (e) => {
      //console.log(e.target.value)
      var select_item = document.getElementById("device")
       var option = document.createElement("option")
//       var xhr1 = new XMLHttpRequest()
//       xhr1.addEventListener('load', () => {
//       this.data = JSON.parse(xhr1.responseText);//parse response text into data object
//       console.log("response from server: " + this.data.result);
//       if (this.data.result === "OK") {
//          console.log(this.data.result)
//          console.log(this.data.location_desc[1])
//          console.log(this.data.sn)
//          for(var i=0;i<this.data.sn.length;i++){
//             option = document.createElement("option")
//              option.text = this.data.location_desc[i]
//              option.value = this.data.location_desc[i]
//              select_item.add(option)
//          }
//        }else{
//              option = document.createElement("option")
//              option.text = "No Devices Available"
//              select_item.add(option)
//        }
        //var select_item_report = document.getElementById("report")
        var xhr2 = new XMLHttpRequest()
        xhr2.addEventListener('load', () => {
        var data = JSON.parse(xhr2.responseText);//parse response text into data object
        data_query = data.report_data_dates
        console.log(data_query)
        device = devices[select_item.selectedIndex]
        if(data.result == 'OK'){
            ApexCharts.exec('chart1', 'updateOptions', {
                series: [{name: "Customers", data: data.report_data_counts}],
                xaxis: {type: "datetime", categories: data.report_data_dates},
                title: {text: 'Customers Per Day - ' + select_item.value}
            })
        }else{
            alert("No data for " + select_item.options[select_item.selectedIndex].value)
            return false
//                           this.props.history.push({
//               pathname: '/user_menu'
//              })
        }

        console.log("counts: " + data.report_data_counts);
        console.log("dates: " + data.report_data_dates);

        //get age demographics
        var xhr3 = new XMLHttpRequest()
        xhr3.addEventListener('load', () => {
        var data = JSON.parse(xhr3.responseText);//parse response text into data object
        console.log(data)
        age_groups = data
        if(data_query.length < 2){
            date_string = data_query[data_query.length-1].toString().replace("'","")
        }else{
            date_string = data_query[data_query.length-1].toString().replace("'","")//change to -2 to default to yesterday
        }


        date_string = date_string.replace("'","")
           ApexCharts.exec('chart2', 'updateOptions', {
                 series: [parseInt(data.age18_24), parseInt(data.age25_34), parseInt(data.age35_44), parseInt(data.age45_54),
                  parseInt(data.age55_64), parseInt(data.age65)],
                   title: {text: 'Customers by Age Group - ' + date_string}
                 //series: [0,226,126,86,5,1]
            })
        //update state of chart 2 here
        //get gender demographics
        var xhr4 = new XMLHttpRequest()
        xhr4.addEventListener('load', () => {
        var data = JSON.parse(xhr4.responseText);//parse response text into data object
        console.log(data.male_count)
        //update state of chart 3 here
            ApexCharts.exec('chart3', 'updateOptions', {
                 series: [parseInt(data.male_count), parseInt(data.female_count)],
                 title: {text: 'Customers by Gender - ' + date_string}
                 //series: [100,200]
            })

        //get hourly data
        var xhr5 = new XMLHttpRequest()
        xhr5.addEventListener('load', () => {
        var data = JSON.parse(xhr5.responseText);//parse response text into data object
        hours = data.hours
        console.log(data.hours)
        console.log(data.counts)

        //update state of chart 4 here
            ApexCharts.exec('chart4', 'updateOptions', {
                series: [{name: "Customers Per Hour", data: data.counts}],
                title: {text: 'Customers Per Hour - ' + date_string},
                xaxis: {type: "datetime",
                    categories: data.hours,
//                    labels: {format: 'HH/TT' }
                    },
                    type: 'line'

            })
                    hours = data.hours
                    console.log(data.hours)
                    console.log(data.counts)
                    hourly_counts = data.counts
                        console.log('hourly_counts: ' + hourly_counts)
                                    //get last hour with value grater than 0
                        var i = hourly_counts.length
                        for (i -1; i >= 0; i--){
                            if(hourly_counts[i] > 0){
                            console.log('index: ' + i.toString() + ' count: ' + hourly_counts[i])
                            break
                            }
                        }
                         hour_string = hours[i]
                         hour_count = i
                         console.log('hour_string: ' + hour_string)
                         console.log('hour_count: ' + hour_count)
                                                //get hourly age demographics
                        var xhr3 = new XMLHttpRequest()
                        xhr3.addEventListener('load', () => {
                        var data = JSON.parse(xhr3.responseText);//parse response text into data object
                        console.log(data)
                        //age_groups = data
//                        date_string = data_query[opt.dataPointIndex].toString().replace("'","")
//                        date_string = date_string.replace("'","")
                           console.log('hour_string: ' + hour_string)
                           ApexCharts.exec('chart5', 'updateOptions', {
                                 series: [parseInt(data.age18_24), parseInt(data.age25_34), parseInt(data.age35_44), parseInt(data.age45_54),
                                  parseInt(data.age55_64), parseInt(data.age65)],
                                   title: {text: 'Customers by Age Group - ' + date_string + " - " + hour_string}
                                 //series: [0,226,126,86,5,1]
                            })

                                                    //get hourly gender demographics
                        var xhr6 = new XMLHttpRequest()
                        xhr6.addEventListener('load', () => {
                        var data = JSON.parse(xhr6.responseText);//parse response text into data object
                        console.log(data)
                            ApexCharts.exec('chart6', 'updateOptions', {
                                 series: [parseInt(data.males), parseInt(data.females)],
                                 title: {text: 'Customers by Gender - ' + date_string + " - " + hour_string}
                                 //series: [100,200]
                            })
                        var xhr7 = new XMLHttpRequest()
                        xhr7.addEventListener('load', () => {
                        var data = JSON.parse(xhr7.responseText);//parse response text into data object
                        console.log(data)
                        if(new String(data.result).valueOf() === 'OK'){
                        console.log(data.songs_played[0][2])
//                        var date_string = new Date(data.songs_played[0][2]).toLocaleString()
//                        console.log(date_string)
                        for (var x = 0; x < data.songs_played.length; x++) {
                        //var date_string = new Date(data.songs_played[x][2]).toLocaleString()
//                        var date_string = new Date(data.songs_played[x][2]).toString()
//                            this.setState({song_data: [...this.state.song_data, ...[{artist: data.songs_played[x][0],
//                            title: data.songs_played[x][1], date_time: date_string}]]})
                            this.setState({song_data: [...this.state.song_data, ...[{artist: data.songs_played[x][0],
                            title: data.songs_played[x][1], date_time: data.songs_played[x][2]}]]})

                        }
                        }
                       //get daily emotion data
                        var xhr8 = new XMLHttpRequest()
                        xhr8.addEventListener('load', () => {
                        var data = JSON.parse(xhr8.responseText);//parse response text into data object
                        console.log(data)
                        console.log(data.result)
                        if(new String(data.result).valueOf() === 'OK'){

                            console.log(parseInt(data.happy_count), parseInt(data.surprise_count), parseInt(data.neutral_count),
								 parseInt(data.sad_count), parseInt(data.fear_count), parseInt(data.disgust_count), parseInt(data.anger_count))
							ApexCharts.exec('emotion1', 'updateOptions', {
								 series: [parseInt(data.happy_count), parseInt(data.surprise_count), parseInt(data.neutral_count),
								 parseInt(data.sad_count), parseInt(data.fear_count), parseInt(data.disgust_count), parseInt(data.anger_count)],
								 title: {text: 'Customers\' Emotions - ' + date_string},
								 //series: [1,2,3,4,5,6,7]
							})

                        }
                        })

                       console.log(date_string_on_load)
						xhr8.open('POST', 'http://3.21.222.196:3035/get_emotion_by_date');//87 is considered unsafe by Chrome
                        xhr8.send(JSON.stringify({'device': device, 'date': date_string}));

                       })
						xhr7.open('POST', 'http://3.21.222.196:3035/get_songs_played_daily');//87 is considered unsafe by Chrome
                        xhr7.send(JSON.stringify({'device': device, 'date': date_string}));
                        })
                        xhr6.open('POST', 'http://3.21.222.196:3035/get_hourly_gender_demographics');//87 is considered unsafe by Chrome
                        xhr6.send(JSON.stringify({'device': device, 'date': date_string, 'hour': hour_count}));

                               })
                        xhr3.open('POST', 'http://3.21.222.196:3035/get_hourly_age_demographics');//87 is considered unsafe by Chrome
                        xhr3.send(JSON.stringify({'device': device, 'date': date_string, 'hour': hour_count}));
        })
        console.log(date_string)
        xhr5.open('POST', 'http://3.21.222.196:3035/get_hourly_data');//87 is considered unsafe by Chrome
        //xhr5.send(JSON.stringify({'device': device, date: data_query[data_query.length-2].toString()}));
        xhr5.send(JSON.stringify({'device': device, date: date_string}));

        })
        xhr4.open('POST', 'http://3.21.222.196:3035/get_gender_demographics');//87 is considered unsafe by Chrome
        if(data_query.length < 2){
            xhr4.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));
        }else{
            xhr4.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));//change to -2 to default to yesterday
        }

        })
        xhr3.open('POST', 'http://3.21.222.196:3035/get_age_demographics');//87 is considered unsafe by Chrome
        if(data_query.length < 2){
            xhr3.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));
        }else{
            xhr3.send(JSON.stringify({'device': device, date: data_query[data_query.length-1].toString()}));//change to -2 to default to yesterday
        }


        })
        xhr2.open('POST', 'http://3.21.222.196:3035/get_report');//87 is considered unsafe by Chrome
        xhr2.setRequestHeader("Content-Type", "application/json");
        //xhr2.send(JSON.stringify({'device': this.data.sn[select_item.selectedIndex], 'report': select_item_report.value}));
        xhr2.send(JSON.stringify({'device': this.data.sn[select_item.selectedIndex], 'report': 'total_customers_by_date'}));

        //})

//        xhr1.open('POST', 'http://3.21.222.196:3035/get_devices');//87 is considered unsafe by Chrome
//        xhr1.setRequestHeader("Content-Type", "application/json");
//        xhr1.send(JSON.stringify({'email': this.readCookie('email')}));
  }

  run_weekly_reports = (e) => {
       console.log(e.target.value)
      //alert("run weekly reports")
      time_selected = e.target.value
      if(time_selected=='weekly'){

        var xhr_w1 = new XMLHttpRequest()
        xhr_w1.addEventListener('load', () => {
        var data = JSON.parse(xhr_w1.responseText);//parse response text into data object
        var result = data.result
        console.log(data)
        if(result=='no_data'){
            alert("No sales data for " + date_string)
        }else{
            if(result=='OK'){
            ApexCharts.exec('chart1', 'updateOptions', {
                series: [{name: "Customers", data: data.weekly_customers_counts}],
                xaxis: {type: "datetime", categories: data.weekly_customers_dates},
                title: {text: 'Customers Per Week'}
            })
            }
        }



        })
        xhr_w1.open('POST', 'http://3.21.222.196:3035/get_weekly_customers');//87 is considered unsafe by Chrome
        xhr_w1.setRequestHeader("Content-Type", "application/json");
        //xhr2.send(JSON.stringify({'device': this.data.sn[select_item.selectedIndex], 'report': select_item_report.value}));
        xhr_w1.send(JSON.stringify({'device': device}));
        }
        if(time_selected=='daily'){
        //alert(time_selected)
        this.viewReport1()
        }

  }

    handleOnDrop = (data) => {
    console.log('---------------------------');
    console.log(data);
    console.log(data.length)
    console.log(data[1])
    console.log('---------------------------');
    var x;
    var sales_data = []
    for (x = 1; x < data.length-1; x++) {
//        //sales_data.push([data[x].data[0], data[x].data[1], data[x].data[2]])
//        //sales_data.push([new Date(data[x].data[0].concat(" ").concat(data[x].data[1])), data[x].data[2], data[x].data[3]])
        //sales_data.push([new Date(data[x].data[0]), data[x].data[1], data[x].data[2]])
        sales_data.push([data[x].data[0], data[x].data[1], data[x].data[2]])
    }
    console.log(sales_data)

        var xhr2 = new XMLHttpRequest()
        xhr2.addEventListener('load', () => {
        var data = JSON.parse(xhr2.responseText);//parse response text into data object
        var result = data.result
        console.log(result)
        if(result=='no_data'){
            alert("No sales data for " + date_string)
        }else{
            if(result=='OK'){
                    var sales_results_final = data.sales_results_final
                console.log(sales_results_final)
                console.log(sales_results_final[0][1])
                for(x = 0; x < sales_results_final.length; x++){
                   ApexCharts.exec('chart4', 'appendSeries', {
                   name: "Sku: " + sales_results_final[x][0],
                   data: sales_results_final[x][1],
                   type: 'column'
                   })
                   ApexCharts.exec('chart4', 'updateOptions', {
                   type: 'column'
                   })

                 }
            }
        }



        })
        xhr2.open('POST', 'http://3.21.222.196:3035/process_sales_data');//87 is considered unsafe by Chrome
        xhr2.setRequestHeader("Content-Type", "application/json");
        //xhr2.send(JSON.stringify({'device': this.data.sn[select_item.selectedIndex], 'report': select_item_report.value}));
        xhr2.send(JSON.stringify({'device': device, 'sales_data': sales_data, 'date': date_string}));

     };

  handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  handleOnRemoveFile = (data) => {
    console.log('---------------------------');
    console.log(data);
    console.log('---------------------------');
  };

  render() {
    const song_data  =  this.state.song_data
  const columns = [{Header: 'Artist', accessor: 'artist'},
                  {Header: 'Title', accessor: 'title', minWidth: 300, className: 'react-table-td'},
                  {Header: 'Date / Time', accessor: 'date_time', minWidth: 70}]
  var date_string2 = this.date_string
  console.log(date_string)
    return (
      <div className='container'>
        <div className="container4">
        <div className="header">
          <div className="menu1">
            <NavLink to="/" activeClassName="is-active" exact={true}>Home</NavLink>
          </div>
          <div className="menu2"><a href="/#setup">Setup</a></div>
          <div className="menu3"><NavLink to="/register" activeClassName="is-active" exact={true}>Register Your Device</NavLink></div>
          <div className="menu5"><NavLink to="/reporting_dashboard" activeClassName="is-active" exact={true}>Reports</NavLink></div>
          <div className="menu4"><NavLink to="/login" activeClassName="is-active" exact={true}>Login</NavLink></div>
        </div>
        <div className="row, color_class1">
          <center>
            <div className="col-12 col-s-12">

              <div className="col-12 col-s-12">
                <img className="center_img2" src="argon_one_case2D_black_custom_blue.png" alt="" />
                <br></br>
                <p className="text_catch3">Reporting Dashboard</p>

              </div>

            </div>
             </center>
             <div className='div1a'>
                                  <label className="text_label1">Select location:&nbsp;&nbsp;</label><br></br>
                                  <select id="device" name="device" size="1" onChange={this.viewReport1}>
                                  </select>
                                  <label className="text_label1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                                  <label className="text_label1">Select time:&nbsp;&nbsp;</label><br></br>
                                  <select id="time_select" name="time_select" size="1" onChange={this.run_weekly_reports}>
                                  <option value='daily'>Daily</option>
                                  <option value='weekly' disabled>Weekly</option>
                                  <option value='monthly' disabled>Monthly</option>
                                  </select>
              </div>
        <div className="">
        <div id='chart1' className="col-3 col-s-3"><Chart options={this.state.options} series={this.state.series} type='area' height='353' width='100%'/></div>
        <div id='chart2' className="col-3 col-s-3"><Chart options={this.state.optionsChart2} series={this.state.seriesChart2} type='pie' height='350' width='100%'/></div>
        <div id='chart3' className="col-3 col-s-3"><Chart options={this.state.optionsChart3} series={this.state.seriesChart3} type='pie' height='350' width='100%'/></div>
        <div id='emotion1' className="col-3 col-s-3"><Chart options={this.state.optionsEmotion1} series={this.state.seriesEmotion1} type='pie' height='350' width='100%'/></div>

        </div>
        <div className="col-12 col-s-12">
        <div id='chart4' className="col-4 col-s-4"><Chart options={this.state.optionsChart4} series={this.state.seriesChart4} type='area' height='350' width='100%'/></div>
        <div id='chart5' className="col-4 col-s-4"><Chart options={this.state.optionsChart5} series={this.state.seriesChart5} type='pie' height='350' width='100%'/></div>
        <div id='chart6' className="col-4 col-s-4"><Chart options={this.state.optionsChart6} series={this.state.seriesChart6} type='pie' height='350' width='100%'/></div>
        </div>
             <table className="csv_table" border='0px'>
             <h5 className="h5">Upload Sales Data</h5>


        <CSVReader
          onDrop={this.handleOnDrop}
          onError={this.handleOnError}
          addRemoveButton
          onRemoveFile={this.handleOnRemoveFile}
        >
          <span className="csv_file_upload_box">Drop CSV file here or click to upload.</span>
        </CSVReader>
        <a href='/pos_template.csv' download><h5 className="pos_download">Download POS Template</h5></a>
                     </table>

        <table className='chart-table' border='0px'>
        <tr>
        <td className='songs_played_label1'><h4 className="h4">Songs Played / Queued - {date_string_on_load}</h4>
        </td>
        <td className='songs_played_label2'><h4 className="h4"></h4>
        </td>
        </tr>
        <tr>
        <td>
        <div className='react-table-div'>

			<ReactTable
			  data={song_data}
			  columns = {columns}
			  defaultPageSize={5}
			/>
        </div>
        </td>
        </tr>
        </table>

                  <br></br><br></br>

          
        </div>

        <div className="footer">
        <br></br>
          <p className="text3, hidden">MJM Technologies, Inc.</p>
          <p className="text3, hidden">xxx-xxx-xxxx</p>
          <p className="text3">&copy; ApolloMusicPlayer.com</p>
          <p className="text3, hidden">&copy;2020 MJM Technologies, Inc.</p>
          <p className="text3">Pat. No. 11,232,469</p>
        <br></br>
        </div>
        </div>
      </div >
    );
  }
}